import { memo } from 'react';

import Dialog from 'core/ui/Dialog';

import Form from './Form';
import {
  TAbstractEntity,
  TAbstractNewEntity,
  TEditorConfig,
} from './interface';

type TProps<
  TContainer extends TAbstractEntity | null,
  TEntity extends TAbstractEntity,
  TNewEntity extends TAbstractNewEntity,
> = {
  entity: TNewEntity | TEntity | null;
  container: TContainer | null;
  onResult: (entity: TEntity | null) => void;
  mode: 'create' | 'change' | null;
  config: TEditorConfig<TContainer, TEntity, TNewEntity>;
};

function EditorDialog<
  TContainer extends TAbstractEntity | null,
  TEntity extends TAbstractEntity,
  TNewEntity extends TAbstractNewEntity,
>({
  mode,
  entity,
  container,
  onResult,
  config,
}: TProps<TContainer, TEntity, TNewEntity>) {
  const isOpen = Boolean(entity && mode);

  return (
    <Dialog isOpen={isOpen}>
      {isOpen &&
        (config.mode === 'withContainer' ? container : true) &&
        entity &&
        mode && (
          <Form<TContainer, TEntity, TNewEntity>
            mode={mode}
            entity={entity}
            container={container as TContainer}
            onResult={onResult}
            config={config}
          />
        )}
    </Dialog>
  );
}

export default memo(EditorDialog) as typeof EditorDialog;
